module.exports = __webpack_public_path__ + "static/img/duigou.9bc85e6f.jpg";